import { deserialize } from 'cerialize'
import { ArticleModel } from 'Pages/knowledge'

export class ProjectModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public slug: string
	@deserialize public position: number
	@deserialize public is_public: boolean
	@deserialize public editable_by_current_user: boolean
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public deleted_at: string
	@deserialize public articles: ArticleModel[]
}
